import { render, staticRenderFns } from "./XCardBasedForm.vue?vue&type=template&id=63be5d8c"
import script from "./XCardBasedForm.vue?vue&type=script&lang=ts"
export * from "./XCardBasedForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports